export class University {

    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.address = data.address;
        this.postal_code = data.postal_code;
        this.province = data.province;
        this.city = data.city;
        this.phone = data.phone;
        this.email = data.email;
        this.website = data.website;
    }
}
